<template>
  <section class="section">
    <div class="dg-container">
      <div class="row row-grid align-items-center pb-1">
        <h1 class="hp-title2">Investors</h1>
      </div>
      <div class="row row-grid align-items-center pb-9 d-flex justify-content-around">
        <div class="col-md-3">
          <img src="img/homepage/investor-gbv.png" class="img-fluid" />
        </div>
        <div class="col-md-3">
          <img src="img/homepage/investor-mexc.png" class="img-fluid" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "investors",
};
</script>

<style scoped>

</style>
